import { render } from "./AdditionalInfoTab.vue?vue&type=template&id=9f3ec058&scoped=true"
import script from "./AdditionalInfoTab.vue?vue&type=script&lang=js"
export * from "./AdditionalInfoTab.vue?vue&type=script&lang=js"

import "./AdditionalInfoTab.vue?vue&type=style&index=0&id=9f3ec058&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9f3ec058"]])

export default __exports__